import { FC } from "react";
import Svg, { Path } from "react-native-svg";

interface FolderFilledProps {
  color?: string;
  size?: number;
}

/**
 * Material Icons `folder` (baseline / filled).
 * Source: https://github.com/google/material-design-icons
 * (src/file/folder/materialicons/24px.svg)
 */
const FolderFilled: FC<FolderFilledProps> = ({
  color = "currentColor",
  size = 24,
}) => (
  <Svg fill={color} height={size} viewBox="0 0 24 24" width={size}>
    <Path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
  </Svg>
);

export default FolderFilled;
